export default "__VITE_ASSET__SUSDAfBg__"